import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const MoreVertSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default MoreVertSVG;
